import { connect } from 'react-redux';

// Selectors
import {
  getAreas,
  getSelectedArea,
  getProductTypes,
  getSelectedCity,
  getSelectedProductType,
  getPollutants,
  getSelectedPollutant,
  getSectors,
  getSelectedSector,
} from 'components/emissions-demo/selectors';

// Actions
import { setArea, setProductType, setPollutant, setCity, setSector, setViewport } from 'components/emissions-demo/actions';

// Components
import TopBar from './component';

const mapStateToProps = state => ({
  areas: getAreas(state),
  selectedArea: getSelectedArea(state),
  productTypes: getProductTypes(state),
  selectedProductType: getSelectedProductType(state),
  pollutants: getPollutants(state),
  selectedPollutant: getSelectedPollutant(state),
  selectedCity: getSelectedCity(state),
  sectors: getSectors(state),
  selectedSector: getSelectedSector(state),
  products: state.emissionsDemo.products.data,
});

const mapDispatchToProps = dispatch => ({
  setArea: (area, resetDefault) => dispatch(setArea(area, resetDefault)),
  setProductType: (productType, resetDefault) => dispatch(setProductType(productType, resetDefault)),
  setPollutant: pollutant => dispatch(setPollutant(pollutant)),
  setSector: sector => dispatch(setSector(sector)),
  setCity: city => dispatch(setCity(city)),
  setViewport: viewport => dispatch(setViewport(viewport)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TopBar);



// WEBPACK FOOTER //
// ./src/components/emissions-demo/components/top-bar/index.js